import axios from 'axios'
import { clone, removeEmpty } from '@/util/libUtil.js'
import qs from "qs"
import readError from '../util.js'

const state = () => ({
    isOpenDialog: false,
    isOpenCrossForm: false,
    isEditableForm: false,
    formType: 'add',
    isAdditional: false,
    MaxNumber: 0,
    editingId: '',
    isActive: false,
    name: '',
    operator: '',
    category: '',
    payment_type: '',
    segment: '',
    color: '',
    commercial_enrichment: '',
    description_file: '',
    MobileForeignMinuteQuantity: 0,
    MobileNationalMinuteQuantity: 0,
    LandLineToLandLineMinuteQuantity: 0,
    LandLineToMobileMinuteQuantity: 0,
    FiberType: '',
    Owner: [],
    price_history: [],
    upfront_history: [],
    DataQuantity: 0,
    price: 0,
    Upfront: 0,
    FamiliaObjetivo: '',
    UploadSpeedQuantity: 0,
    DownloadSpeedQuantity: 0,
    SelectedPromotions: [],
    SelectedAditionals: [],
    SelectedSVA: [],
    UploadSpeedUnit: 'Mb',
    DownloadSpeedUnit: 'Mb',
    DataUnit: 'GB',

    tariffManagement: {
        tariffs: [],
        totalEntries: 0,
        isLoading: false,
        page: 1,
        params: {}
    },
    paths: {
        tariffsPath: '/api/servicios/tarifas/',
        additionalsPath: '/api/servicios/adicionales/',
    }
})

const initialState = { ...state() }

const mutations = {
    resetStore: (state) => {
        let copy = [...state.tariffManagement]
        initialState.tariffManagement = copy
        Object.assign(state, initialState)
    },
    isOpenCrossForm: (state, val) => {
        state.isOpenCrossForm = val;
    },
    tariffManagementPage: (state, val) => {
        state.tariffManagement.page = val;
    },
    tariffManagementTarrifs: (state, val) => {
        state.tariffManagement.tariffs = clone(val);
    },
    tariffManagementParams(state, val) {
        state.tariffManagement.params = val
    },
    tariffManagementIsLoading(state, val) {
        state.tariffManagement.isLoading = val
    },
    tariffManagement(state, val) {
        state.tariffManagement.totalEntries = val.count
        state.tariffManagement.tariffs = val.results
    },
    price_history: (state, val) => {
        state.price_history = clone(val);
    },
    upfront_history: (state, val) => {
        state.upfront_history = clone(val);
    },
    FamiliaObjetivo: (state, val) => {
        state.FamiliaObjetivo = val;
    },
    isOpenDialog: (state, val) => {
        state.isOpenDialog = val;
    },
    formType: (state, val) => {
        state.formType = val;
    },
    editingId: (state, val) => {
        state.editingId = val;
    },
    name: (state, val) => {
        state.name = val;
    },
    operator: (state, val) => {
        state.operator = val;
    },
    category: (state, val) => {
        state.category = val;
    },
    payment_type: (state, val) => {
        state.payment_type = val;
    },
    isAdditional: (state, val) => {
        state.isAdditional = val;
    },
    segment: (state, val) => {
        state.segment = val;
    },
    color: (state, val) => {
        state.color = val;
    },
    price: (state, val) => {
        state.price = val;
    },
    commercial_enrichment: (state, val) => {
        state.commercial_enrichment = val;
    },
    description_file: (state, val) => {
        state.description_file = val;
    },
    MaxNumber: (state, val) => {
        state.MaxNumber = val;
    },
    MobileForeignMinuteQuantity: (state, val) => {
        state.MobileForeignMinuteQuantity = val
    },
    MobileNationalMinuteQuantity: (state, val) => {
        state.MobileNationalMinuteQuantity = val
    },
    LandLineToLandLineMinuteQuantity: (state, val) => {
        state.LandLineToLandLineMinuteQuantity = val
    },
    LandLineToMobileMinuteQuantity: (state, val) => {
        state.LandLineToMobileMinuteQuantity = val
    },
    DataQuantity: (state, val) => {
        state.DataQuantity = val
    },
    Upfront: (state, val) => {
        state.Upfront = val
    },
    MobilePVP: (state, val) => {
        state.MobilePVP = val
    },
    LandLinePVP: (state, val) => {
        state.LandLinePVP = val
    },
    UploadSpeedQuantity: (state, val) => {
        state.UploadSpeedQuantity = val
    },
    DownloadSpeedQuantity: (state, val) => {
        state.DownloadSpeedQuantity = val
    },
    FiberType: (state, val) => {
        state.FiberType = val
    },
    Owner: (state, val) => {
        state.Owner = val
    },
    UploadSpeedUnit: (state, val) => {
        state.UploadSpeedUnit = val
    },
    DownloadSpeedUnit: (state, val) => {
        state.DownloadSpeedUnit = val
    },
    isActive: (state, val) => {
        state.isActive = val
    },
    DataUnit: (state, val) => {
        state.DataUnit = val
    },
    SelectedPromotions: (state, val) => {
        state.SelectedPromotions = val
    },
    SelectedAditionals: (state, val) => {
        state.SelectedAditionals = val
    },
    SelectedSVA: (state, val) => {
        state.SelectedSVA = val
    },
    isEditableForm: (state, val) => {
        state.isEditableForm = val
    },
}

const actions = {
    async updateTariffManagementParams({ commit, state }, params) {
        let newParams = { ...state.tariffManagement.params, ...params }
        newParams = removeEmpty(newParams) // eliminate nulls
        commit('tariffManagementParams', newParams)
    },
    async getTariffs({ dispatch, getters, rootGetters, state, commit }) {
        try {
            commit('tariffManagementIsLoading', true)
            commit('ManagementBase/loadingItems', true, { root: true })
            let params = clone(state.tariffManagement.params)
            
            if(!'itemsPerPage' in params || !params['itemsPerPage']){
                params['itemsPerPage'] = rootGetters['ManagementBase/itemsPerPage']
            }

            let resp = await axios.get(getters.getEndpointFromPath(state.paths.tariffsPath), {
                params: params,
                paramsSerializer: params => {
                    return qs.stringify(params, { arrayFormat: 'brackets', skipNulls: true })
                },
            })
            commit('tariffManagement', resp.data)
            commit('tariffManagementIsLoading', false)
            commit('ManagementBase/loadingItems', false, { root: true })

            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Tarifas Cargadas Correctamente'
            }, { root: true })
        } catch (error){
            let read = readError.readError(error)

            if('detail' in read && read.detail == 'Página inválida.'){
                dispatch('updateTariffManagementParams', { page: 1 })
                dispatch('getTariffs')
            }else{
                commit('tariffManagementIsLoading', false)
                dispatch('util/showStatusSnackBar', {
                    statusType: 'error',
                    message: 'No se pudo cargar el contenido de Tarifas'
                }, { root: true })
            }
        }
    },
    async addTariff({ state, getters, dispatch, rootState }) {
        let tariff = {
            category: state.category,
            color: state.color,
            commercial_enrichment: state.commercial_enrichment,
            description_file: state.description_file,
            fixed_line_info: null,
            mobile_line_info: null,
            name: state.name,
            payment_type: state.payment_type,
            price_value: state.price,
            is_active: state.isActive,
            operator: state.operator,
            segment: state.segment,
            promotions: state.SelectedPromotions,
            additional_lines: state.SelectedAditionals,
            svas: state.SelectedSVA
        }


        // podria poner state.category!="fixed_line" pero vayamos a que salga otra categoria y la líe
        if (state.category == "fixed_line" || state.category == "mobile_fixed_line" || state.category == "convergent") {
            tariff['fixed_line_info'] = {
                "type": state.FiberType,
                "owners": state.Owner,
                "upload_speed": {
                    "unit": state.UploadSpeedUnit,
                    "amount": state.UploadSpeedQuantity
                },
                "download_speed": {
                    "unit": state.DownloadSpeedUnit,
                    "amount": state.DownloadSpeedQuantity
                },
                "voice_to_fixed": {
                    "unit": "min",
                    "amount": state.LandLineToMobileMinuteQuantity
                },
                "voice_to_mobile": {
                    "unit": "min",
                    "amount": state.LandLineToLandLineMinuteQuantity
                }
            }
        }

        if (state.category == "mobile_line" || state.category == "convergent") {
            tariff['mobile_line_info'] = {
                "mobile_line_data": {
                    "unit": state.DataUnit,
                    "amount": state.DataQuantity
                },
                "mobile_line_voice": {
                    "unit": "min",
                    "amount": state.MobileNationalMinuteQuantity
                }
            }
        }

        // Si el formulario tiene el campo de minutos al extranjero relleno lo añadiremos 
        // al JSON que se crea para esa tarifa
        if (state.MobileForeignMinuteQuantity && state.MobileForeignMinuteQuantity != 0) {
            tariff['mobile_line_info']['voice_to_foreign'] = {
                "unit": "min",
                "amount": state.MobileForeignMinuteQuantity
            }
        }

        if (state.isAdditional) {
            let additional = {
                max_number: state.MaxNumber,
                name: state.name,
                promotions: [],
                operator: state.operator,
                segment: state.segment,
                is_active: state.isActive,
                mobile_line_info: {
                    "mobile_line_data": {
                        "unit": state.DataUnit,
                        "amount": state.DataQuantity
                    },
                    "mobile_line_voice": {
                        "unit": "min",
                        "amount": state.MobileNationalMinuteQuantity
                    }
                },
            }

            if (state.MobileForeignMinuteQuantity && state.MobileForeignMinuteQuantity != 0) {
                additional['mobile_line_info']['voice_to_foreign'] = {
                    "unit": "min",
                    "amount": state.MobileForeignMinuteQuantity
                }
            }
        }


        try {
            await axios.post(getters.getEndpointFromPath(state.paths.tariffsPath), tariff)

            if (state.isAdditional) {
                await axios.post(getters.getEndpointFromPath(state.paths.additionalsPath), additional)
                dispatch('additionalManagement/getAdditionals', null, { root: true })
            }

            let params = {
                search: rootState.util.navBarSearchField,
                itemsPerPage: 15,
                page: 1,
            };

            dispatch('getTariffs', params)
            dispatch('ManagementBase/promotionManagement/getTariffDropDown', {}, { root: true })

            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Tarifa añadida correctamente',
            }, { root: true })
        } catch (error) {
            dispatch('util/showStatusSnackBar', {
                error: error,
                timeout: 8000,
                statusType: 'error',
                message: 'Error al añadir tarifa',
            }, { root: true })
        }
    },
    async editTariff({ state, getters, dispatch, rootState }) {
        let editedTariff = {
            category: state.category,
            color: state.color,
            commercial_enrichment: state.commercial_enrichment,
            description_file: state.description_file,
            fixed_line_info: null,
            mobile_line_info: null,
            name: state.name,
            payment_type: state.payment_type,
            // price: state.price,
            is_active: state.isActive,
            operator: state.operator,
            segment: state.segment,
            promotions: state.SelectedPromotions,
            additional_lines: state.SelectedAditionals,
            svas: state.SelectedSVA,
        }


        // podria poner state.category!="fixed_line" pero vayamos a que salga otra categoria y la líe
        if (state.category == "fixed_line" || state.category == "mobile_fixed_line" || state.category == "convergent") {
            editedTariff['fixed_line_info'] = {
                "type": state.FiberType,
                "owners": state.Owner,
                "upload_speed": {
                    "unit": state.UploadSpeedUnit,
                    "amount": state.UploadSpeedQuantity
                },
                "download_speed": {
                    "unit": state.DownloadSpeedUnit,
                    "amount": state.DownloadSpeedQuantity
                },
                "voice_to_fixed": {
                    "unit": "min",
                    "amount": state.LandLineToMobileMinuteQuantity
                },
                "voice_to_mobile": {
                    "unit": "min",
                    "amount": state.LandLineToLandLineMinuteQuantity
                }
            }
        }

        if (state.category == "mobile_line" || state.category == "convergent") {
            editedTariff['mobile_line_info'] = {
                "mobile_line_data": {
                    "unit": state.DataUnit,
                    "amount": state.DataQuantity
                },
                "mobile_line_voice": {
                    "unit": "min",
                    "amount": state.MobileNationalMinuteQuantity
                }
            }
        }

        // Si el formulario tiene el campo de minutos al extranjero relleno lo añadiremos 
        // al JSON que se crea para esa tarifa
        if (state.MobileForeignMinuteQuantity && state.MobileForeignMinuteQuantity != 0) {
            editedTariff['mobile_line_info']['voice_to_foreign'] = {
                "unit": "min",
                "amount": state.MobileForeignMinuteQuantity
            }
        }

        if (state.isAdditional) {
            let editedAdditional = {
                max_number: state.MaxNumber,
                name: state.name,
                promotions: [],
                operator: state.operator,
                segment: state.segment,
                is_active: state.isActive,
                mobile_line_info: {
                    "mobile_line_data": {
                        "unit": state.DataUnit,
                        "amount": state.DataQuantity
                    },
                    "mobile_line_voice": {
                        "unit": "min",
                        "amount": state.MobileNationalMinuteQuantity
                    }
                },
            }

            if (state.MobileForeignMinuteQuantity && state.MobileForeignMinuteQuantity != 0) {
                editedAdditional['mobile_line_info']['voice_to_foreign'] = {
                    "unit": "min",
                    "amount": state.MobileForeignMinuteQuantity
                }
            }
        }



        try {

            await axios.put(getters.getEndpointFromPath(state.paths.tariffsPath) + state.editingId + '/', editedTariff)

            if (state.isAdditional) {
                await axios.post(getters.getEndpointFromPath(state.paths.additionalsPath), editedAdditional)
                dispatch('additionalManagement/getAdditionals', null, { root: true })
            }

            let params = {
                search: rootState.util.navBarSearchField,
                itemsPerPage: 15,
                page: 1,
            };

            dispatch('getTariffs', params)
            dispatch('ManagementBase/promotionManagement/getTariffDropDown', {}, { root: true })

            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Tarifa añadida correctamente',
            }, { root: true })
        } catch (error) {
            dispatch('util/showStatusSnackBar', {
                error: error,
                timeout: 8000,
                statusType: 'error',
                message: 'Error al añadir tarifa',
            }, { root: true })
        }
    },
    async delete({ state, dispatch, getters, rootState }, item) {
        try {
            await axios.delete(getters.getEndpointFromPath(state.paths.tariffsPath) + item.id + '/')
            let params = {
                search: rootState.util.navBarSearchField,
                itemsPerPage: 15,
                page: 1,
            };

            dispatch('getTariffs', params)
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Entrada borrada'
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'No se pudo eliminar la entrada'
            }, { root: true })
        }
    },
    // resetStore({ state}) {
    //     let copy = [...state.tariffs]
    //     let tableItemCountCopy = state.tableItemCount
    //     let pageCopy = state.page
    //     initialState.tariffs = copy
    //     initialState.tableItemCount = tableItemCountCopy
    //     initialState.page = pageCopy
    //     Object.assign(state, initialState)
    // },
}

const getters = {
    getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
        rootState.general.host + endpoint
    )
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}